import { render } from "./Paytm.vue?vue&type=template&id=081899f4&scoped=true&ts=true"
import script from "./Paytm.vue?vue&type=script&lang=ts"
export * from "./Paytm.vue?vue&type=script&lang=ts"

import "./Paytm.vue?vue&type=style&index=0&id=081899f4&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-081899f4"]])

export default __exports__